import {Link} from "@/i18n/routing";
import ProductDetailsColors from "./ProductDetailsColors";
import ProductDetailsSizes from "./ProductDetailsSizes";
import {useTranslations} from 'next-intl';
import {ProductStatus} from '@/libs/constants/common.constants';
import ProductDetailsActions from '@/components/shared/products/ProductDetailsActions';
import ProductDetailsCategory from '@/components/shared/products/ProductDetailsCategory';
import ProductDetailsBrand from '@/components/shared/products/ProductDetailsBrand';
import ProductPrice from '@/components/shared/cards/ProductPrice';
import {APP_URL} from '@/libs/constants/url.constants';
import ShareSection from '@/components/shared/share/ShareSection';

export default function ProductDetailsRight({ product, isModal, clientType }) {
  const t = useTranslations('catalog');
  const сt = useTranslations('country');
  
  return (
    <div id="details" className="modal-product-info shop-details-info pl-0">
      {/* ratings */}
      {
        product.reviewComputed ? (
            <div className="product-ratting" title={product.reviewComputed.average}>
              <ul>
                {
                  product.reviewComputed.stars.map((icon, i) => (
                      <li key={i}>
                        <i className={icon}></i>
                      </li>
                  ))
                }
                {/*<li className="review-total">*/}
                {/*  - {product.reviewComputed.average}*/}
                {/*</li>*/}
                <li className="review-total ms-2">
                  {isModal ? (
                      `( ${product.reviewComputed.average} • ${t('countReviews', {count: product.reviewComputed.count})} )`
                  ) : (
                      <Link href="#review-section">
                        ( {product.reviewComputed.average} • {t('countReviews', {count: product.reviewComputed.count})} )
                      </Link>
                  )}
                </li>
              </ul>
            </div>
        ) : ''
      }
      {/* title */}
      <h1>{product.brand ? `${product.brand.title} - ` : ''}{product.title}</h1>
      {/* price */}
      <ProductPrice
          className="text-nowrap"
          price={product.price}
          clientType={clientType}
      />
      {/* description */}
      <div className="modal-product-brief">
        <p>{product.descriptionShort}</p>
      </div>
      {/* category, availability */}
      <div className={`modal-product-meta ltn__product-details-menu-1 ${!isModal ? "mb-30" : ""}`}>
        <ul>
          <li>
            <strong>{t('article')}:</strong>
            <span>{product.id}</span>
          </li>
          {
            !!product.status ? (
                <li>
                  <strong>{t('availability')}:</strong>
                  <span>
										{t(`productStatuses.${product.status}`)}
                    {
                      product.quantity > 0 && product.status === ProductStatus.IN_STOCK ? (
                          ` (${product.quantity}${t('pc')})`
                      ) : ''
                    }
									</span>
                </li>
            ) : ''
          }
          {
            product.category || product.subcategory ? (
                <ProductDetailsCategory
                    isModal={isModal}
                    category={product?.category}
                    subcategory={product?.subcategory}
                />
            ) : ''
          }
          { product.brand ? <ProductDetailsBrand isModal={isModal} brand={product.brand}/> : '' }
          {/* colors */}
          {product.colors ? <ProductDetailsColors setCurrentColor={(color) => {}} /> : '' }
          {
            product.volume ? (
                <li>
                  <strong>{t('volume')}:</strong>
                  <span>{product.volume}</span>
                </li>
            ) : ''
          }
          {
            product.country ? (
                <li>
                  <strong>{t('country')}:</strong>
                  <span>{сt(product.country)}</span>
                </li>
            ) : ''
          }
          {
            product.color ? (
                <li>
                  <div className="ltn__color-widget clearfix">
                    <strong className="alignleft">{t('color')}</strong>
                    <ul>
                      <li style={{ backgroundColor: product.color }}>
                        <span></span>
                      </li>
                    </ul>
                  </div>
                </li>
            ) : ''
          }
          {
            product.size ? (
                <li>
                  <strong>{t('size')}:</strong>
                  <span>{product.size}</span>
                </li>
            ) : ''
          }
          {
            product.expiration ? (
                <li>
                  <strong>{t('expiration')}:</strong>
                  <span>{product.expiration}</span>
                </li>
            ) : ''
          }
          {/* sizes */}
          { product.sizes ? <ProductDetailsSizes setCurrentSize={(size) => {}} /> : '' }
        </ul>
      </div>
      {/* add to cart */}
      <ProductDetailsActions product={product}/>
      <hr />
      {/* socials */}
      <ShareSection
          urlLink={`${APP_URL}/products/${product.alt}`}
          title={product.title}
      />
    </div>
  );
};
